var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsageMetrics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "340px",
    height: "190px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 73.03 40.81",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .fil11 {fill:#00AAAD}\r\n    .fil8 {fill:#267A8C}\r\n    .fil3 {fill:#3A4553}\r\n    .fil9 {fill:#50BDD6}\r\n    .fil0 {fill:#C4337C}\r\n    .fil2 {fill:gainsboro}\r\n    .fil5 {fill:#E9E9E9}\r\n    .fil6 {fill:#F2F2F2}\r\n    .fil1 {fill:#F9D821}\r\n    .fil7 {fill:#FFB800}\r\n    .fil10 {fill:white}\r\n    .fil12 {fill:#3A4553;fill-rule:nonzero}\r\n    .fil4 {fill:white;fill-opacity:0.019608}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 73.03,
    height: 40.81
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2000857174960"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    transform: "matrix(-1.57973E-14 0.596472 -0.767342 -2.03227E-14 39.685 7.06829)",
    width: 8.04,
    height: 0.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    transform: "matrix(-2.03227E-14 0.767343 -0.767342 -2.03227E-14 36.8829 5.69501)",
    width: 8.04,
    height: 0.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    transform: "matrix(-1.57973E-14 0.596472 -0.767342 -2.03227E-14 34.3692 7.06829)",
    width: 8.04,
    height: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil1",
    transform: "matrix(-2.03227E-14 0.767343 -0.767342 -2.03227E-14 39.4386 7.06829)",
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil1",
    transform: "matrix(-2.03227E-14 0.767343 -0.767342 -2.03227E-14 36.6366 5.69501)",
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil1",
    transform: "matrix(-2.03227E-14 0.767343 -0.767342 -2.03227E-14 34.1228 7.06829)",
    r: 0.91
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "32.6,31.58 32.54,32.11 41.3,34.58 40.62,31.63 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M26.27 14.55l20.72 0c0.93,0 1.7,0.74 1.7,1.63l0 12.63 -24.12 0 0 -12.63c0,-0.89 0.77,-1.63 1.7,-1.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M26.42 14.67l20.19 0c0.91,0 1.65,0.73 1.65,1.62l0 12.52 -23.49 -12.52c0,-0.89 0.74,-1.62 1.65,-1.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M48.69 28.81l0 1.88c0,0.55 -0.47,1.01 -1.04,1.01l-22.1 0c-0.57,0 -1.04,-0.46 -1.04,-1.01l0 -1.88 24.18 0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil6",
    points: "31.99,34.37 32.63,31.74 41.26,34.35 "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil7",
    cx: 47.62,
    cy: 29.85,
    r: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil8",
    cx: 46.63,
    cy: 29.85,
    r: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil9",
    cx: 45.69,
    cy: 29.85,
    r: 0.31
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2000857190416"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fil10",
    x: 26.52,
    y: 11.42,
    width: 20.23,
    height: 14.23,
    rx: 1.08,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil11",
    d: "M27.6 11.23l18.07 0c0.59,0 1.08,0.32 1.08,0.71l0 1.23 -20.23 0 0 -1.23c0,-0.39 0.49,-0.71 1.08,-0.71z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil8",
    cx: 28.94,
    cy: 12.19,
    r: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil8",
    cx: 27.78,
    cy: 12.19,
    r: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil10",
    x: 31.03,
    y: 11.85,
    width: 13.58,
    height: 0.75
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil12",
    d: "M31.35 19.47l0 -0.67 3.85 -1.63 0 0.72 -3.05 1.25 3.05 1.27 0 0.72 -3.85 -1.66zm4.31 2.65l1.7 -6.04 0.57 0 -1.69 6.04 -0.58 0zm6.57 -2.65l-3.85 1.66 0 -0.72 3.05 -1.27 -3.05 -1.25 0 -0.72 3.85 1.63 0 0.67z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2000857194096"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    x: 17.78,
    y: 18.79,
    width: 6.73,
    height: 0.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    x: 15.86,
    y: 22.72,
    width: 8.66,
    height: 0.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    x: 17.78,
    y: 26.25,
    width: 6.73,
    height: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil1",
    cx: 17.78,
    cy: 19.14,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil1",
    cx: 15.86,
    cy: 23.07,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil1",
    cx: 17.78,
    cy: 26.6,
    r: 0.98
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2000857195760"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    x: 48.69,
    y: 18.79,
    width: 6.73,
    height: 0.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    x: 48.69,
    y: 22.72,
    width: 8.66,
    height: 0.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    x: 48.69,
    y: 26.25,
    width: 6.73,
    height: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil1",
    cx: 55.42,
    cy: 19.14,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil1",
    cx: 57.34,
    cy: 23.07,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil1",
    cx: 55.42,
    cy: 26.6,
    r: 0.98
  })), /*#__PURE__*/React.createElement("rect", {
    className: "fil5",
    x: 29.84,
    y: 34.36,
    width: 13.63,
    height: 1.35,
    rx: 0.72,
    ry: 0.68
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageMetrics);
export default __webpack_public_path__ + "static/media/usage-metrics.1171760a02b6db9561ca017ec181b4a1.svg";
export { ForwardRef as ReactComponent };